import React from 'react';
import styled from 'styled-components';
import { system, extractSysProps } from './system';

// Replicates @actovos-consulting-group/ui-core Block:
//   A styled div that accepts the full set of system props
//   (space, color, layout, flexbox, background, border, position) plus transition.
//   Designed to be used directly or as a base for styled() extension.

export type BlockProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
  as?: any;
  transition?: string;
  [key: string]: any;
};

interface StyledBlockInternalProps {
  $sys: Record<string, any>;
  $transition?: string;
  [key: string]: any;
}

const StyledBlock = styled.div<StyledBlockInternalProps>`
  ${(p: any) => system(p.$sys, p.theme)}
  ${(p: any) => (p.$transition ? `transition: ${p.$transition};` : '')}
`;

const Block: React.FC<BlockProps> = ({ children, transition, ...props }) => {
  const { sys, rest } = extractSysProps(props);

  return (
    <StyledBlock $sys={sys} $transition={transition} {...rest}>
      {children}
    </StyledBlock>
  );
};

Block.displayName = 'Block';

export default Block;
